import { CommonTabbarState, TabRoute } from '@/global/components/common-tabbar';
import './index.less';
import { useEffect, useState, useRef, useContext } from 'react';
import { TAB_TYPE } from '@/enums/tab-type';
import { CommonTabbarContext } from '@/App';
import { useParams } from 'react-router-dom';
import { Select, Skeleton, Table } from 'antd';
import { getMonitorParameterRelationsByProjectId, updateMonitorParameterDq, updateMonitorParameterDqForRelation } from '@/api/monitor-object/monitor-parameter';
import { MonitorParameter } from '@/global/interface/monitor-object/monitor-parameter';
import TnMessage from '@/global/components/message';
import { SENSOR_TYPE_LIST, getSensorTypeName } from '@/enums/sensor-type';
import { WARNING_LEVEL, WARNING_LEVEL_DICT, getWarningLevelName } from '@/enums/warning-level';
import { DRAW_MAIN_KEY } from '..';
import axios from 'axios';
import { getGlobalSensors } from '@/api/lib/lib-sensor';
import { GlobalSensor } from '@/global/interface/lib-device/global-sensor';
import classNames from 'classnames';
import { MONITOR_PARAMETER_TYPE } from '@/enums/monitor-parameter-type';
import { getSensors } from '@/api/device/sensor';
import { Sensor } from '@/global/interface/device/sensor';
import SelectSensorRelationModal from './select-sensor';
import { DEVICE_TYPE } from '@/enums/device-type';
import { updateMonitorObject } from '@/api/monitor-object/monitor-object';


interface IProps {

}

export default function MonitorRelationPanel(props: IProps) {
    const { projectId } = useParams();
    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext); // tabbar上下文
    const [tableList, setTableList] = useState<MonitorParameter[]>([]); // 表格数据
    const [globalSensors, setGlobalSensors] = useState<GlobalSensor[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const [selectSensorVisiable, setSelectSensorVisiable] = useState<boolean>(false); // 打开选择设备弹窗
    const [selectParam, setSelectParam] = useState<MonitorParameter>(); // 点击选择，选中的参数
    const [hoverRow, setHoverRow] = useState<MonitorParameter>(); // 悬浮行
    const [modalLoading, setModalLoading] = useState<boolean>(false); // 弹窗的loading

    useEffect(() => {
        generateData();

        getGlobalSensors().then(res => {
            if (res.status === 200) {
                let data: GlobalSensor[] = res.data || [];
                setGlobalSensors(data);
            }
        })
    }, [])

    const generateData = () => {
        setLoading(true);
        getMonitorParameterRelationsByProjectId(+projectId).then(res => {
            if (res.status === 200) {
                let data: MonitorParameter[] = res.data || [];
                setTableList(data);
                // 新增页签
                let addTab: TabRoute = {
                    title: '传感器关联表',
                    url: `${TAB_TYPE.MONITOR_RELATION}`,
                    closable: true
                }
                commonTabbarContext.pushRoute(addTab);
            }
        }).catch(err => {
            TnMessage.error("获取数据失败");
            commonTabbarContext.navigate(`${TAB_TYPE.DRAW}/${DRAW_MAIN_KEY}`)
        }).finally(() => {
            setLoading(false);
        })
    }

    // 切换传感器类型或型号
    const onRowChange = (value: any, row: MonitorParameter, field: string) => {
        if (!row) return;
        if (field === 'globalSensorMarking') {
            // 切换型号,清空传感器属性
            let data: MonitorParameter = {
                sensorType: row.sensorType,
                globalSensorId: value,
                sensorId: null,
                sensorParameterId: null,
                id: row.id,
            }
            updateMonitorParameterDqForRelation(+projectId, row.id, data).then(res => {
                if (res.status === 200) {
                    generateData();
                    TnMessage.success("编辑成功");
                }
            }).catch(err => {
                TnMessage.success("编辑失败");
            })

        } else if (field === 'sensorType') {
            // 切换类型,清空其他相关传感器属性
            let data: MonitorParameter = {
                sensorType: value,
                globalSensorId: null,
                sensorId: null,
                sensorParameterId: null,
                id: row.id,
            }
            updateMonitorParameterDqForRelation(+projectId, row.id, data).then(res => {
                if (res.status === 200) {
                    generateData();
                    TnMessage.success("编辑成功");
                }
            }).catch(err => {
                TnMessage.success("编辑失败");
            })
        }
    }

    // 选择传感器完成的回调
    const onSelectSensorFinish = (sensor: Sensor) => {
        let sensorParameterId = sensor?.sensorParameters?.find(item => item.globalMonitorParameterId === selectParam?.globalMonitorParameterId)?.id;

        let data: MonitorParameter = {
            sensorType: selectParam?.sensorType,
            globalSensorId: selectParam?.globalSensorId,
            sensorId: sensor.id,
            sensorParameterId: sensorParameterId,
            id: selectParam.id,
        }
        setModalLoading(true);
        updateMonitorParameterDqForRelation(+projectId, selectParam.id, data).then(res => {
            if (res.status === 200) {
                generateData();
                setSelectSensorVisiable(false);
                setSelectParam(null);
                setModalLoading(false);
                TnMessage.success("编辑成功");
            }
        }).catch(err => {
            TnMessage.success("编辑失败");
        }).finally(() => {
            setModalLoading(false);
        })
    }

    // 切换启动状态
    const toggleMonitorObjectStart = (monitorObjectId: number, start: boolean, needRender = false) => {
        updateMonitorObject(+monitorObjectId, { start: start }).then(res => {
            if (needRender) {
                TnMessage.success("更新成功");
                generateData();
            }
        }).catch(err => {
            TnMessage.error("更新失败");
        })
    }

    return (
        <div className='monitor-relation-container'>
            <Skeleton loading={loading} active>
                <div className="monitor-relation-table">
                    <div className="head-row" style={{ marginBottom: 4 }}>
                        <div className="head-cell flex-1">监测对象</div>
                        <div className="head-cell flex-1">状态</div>
                        <div className="head-cell flex-2">监测参数</div>
                        <div className="head-cell flex-2">直接参数</div>
                        <div className="head-cell flex-2">传感器类别</div>
                        <div className="head-cell flex-3">传感器型号</div>
                        <div className="head-cell flex-2">传感器编号</div>
                        <div className="head-cell flex-1">地址码</div>
                        <div className="head-cell flex-1">通道</div>
                        <div className="head-cell flex-2">采集设备编号</div>
                        <div className="head-cell flex-2">采集设备IMEI</div>
                        <div className="head-cell flex-1">操作</div>
                        <div className="head-cell flex-1">预警等级</div>
                    </div>
                    {tableList?.map((item: MonitorParameter, key) => {
                        let showDivider = false;
                        let showBottom = false;
                        let monitorObjectName = item?.monitorObjectName || '';
                        let superName = `${item?.superMonitorParameterEncoding || ''} ${item?.superMonitorParameterName || ''} ${item?.superMonitorParameterCode || ''}`;
                        let name = `${item?.encoding || ''} ${item?.name || ''} ${item?.code || ''}`;
                        let start = item?.monitorObjectStart ? '进行中' : '关闭';
                        if (key > 0) {
                            if (tableList[key]?.monitorObjectId !== tableList[key - 1]?.monitorObjectId) {
                                showDivider = true;
                            } else {
                                monitorObjectName = '';

                            }
                            if ((tableList[key]?.superMonitorParameterName === tableList[key - 1]?.superMonitorParameterName)
                                && (tableList[key]?.superMonitorParameterEncoding === tableList[key - 1]?.superMonitorParameterEncoding)
                                && (tableList[key]?.superMonitorParameterCode === tableList[key - 1]?.superMonitorParameterCode)) {
                                superName = '';
                            }
                        }
                        if (key != tableList?.length - 1) {
                            if (tableList[key]?.superMonitorParameterId === tableList[key + 1]?.superMonitorParameterId) {
                                showBottom = true;
                            }
                        }
                        let height = 20;
                        if (!superName) height += 2;
                        if (showBottom) height += 2;
                        return (
                            <>
                                {showDivider && <div className='divider'></div>}
                                <div className={classNames({
                                    "body-row": true,
                                    "body-row-hover": item?.id === hoverRow?.id || hoverRow?.superMonitorParameterId === item?.superMonitorParameterId,
                                })}
                                    onMouseEnter={() => setHoverRow(item)}
                                    onMouseLeave={() => setHoverRow(null)}
                                    style={{
                                        paddingTop: !!superName ? 0 : 2,
                                        paddingBottom: showBottom ? 2 : 0,
                                        marginBottom: !showBottom ? 8 : 0,
                                        height: height,
                                    }}
                                >
                                    <div className="body-cell flex-1">
                                        {monitorObjectName && <div className='have-border' onClick={() => {
                                            commonTabbarContext.navigate(`${TAB_TYPE.MONITOR_OBJECT}/${item?.monitorObjectId}`)
                                        }}>
                                            {monitorObjectName}
                                        </div>}
                                    </div>
                                    <div className="body-cell flex-1">
                                        {monitorObjectName && <div className={classNames({
                                            'doing': item?.monitorObjectStart,
                                            'close': !item?.monitorObjectStart,
                                        })} onClick={() => toggleMonitorObjectStart(item?.monitorObjectId, !item?.monitorObjectStart, true)}>
                                            {start}
                                        </div>}
                                    </div>
                                    <div className="body-cell flex-2">
                                        {superName && <div className='have-border' onClick={() => {
                                            commonTabbarContext.navigate(`${TAB_TYPE.MONITOR_PARAMETER}/${item?.superMonitorParameterId}`)
                                        }}>{superName}</div>}
                                    </div>
                                    <div className="body-cell flex-2">
                                        {name}
                                    </div>
                                    <div className="body-cell flex-2 select">
                                        <Select
                                            value={item?.sensorType}
                                            onChange={(e) => onRowChange(e, item, 'sensorType')}
                                        >
                                            {SENSOR_TYPE_LIST.map((item => (
                                                <Select.Option key={item.value} value={item.value}>{item.label}</Select.Option>
                                            )))}
                                        </Select>
                                    </div>
                                    <div className="body-cell flex-3 select">
                                        <Select
                                            value={item?.globalSensorMarking}
                                            onChange={(e) => onRowChange(e, item, 'globalSensorMarking')}
                                        >
                                            {globalSensors?.filter(gs => item?.sensorType === gs?.type)?.map((item => (
                                                <Select.Option key={item?.id} value={item?.id}>{item?.marking || ''}</Select.Option>
                                            )))}
                                        </Select>
                                    </div>
                                    <div className="body-cell flex-2">
                                        {item?.sensorCode && <div className='have-border' onClick={() => {
                                            commonTabbarContext.navigate(`${TAB_TYPE.DEVICE}/${item?.sensorId}/${DEVICE_TYPE.SENSOR}`)
                                        }}>{item?.sensorCode || ''}</div>}
                                        {!item?.sensorCode && <div className='have-border'
                                            style={{ width: 40 }}
                                            onClick={() => {
                                                setSelectSensorVisiable(true);
                                                setSelectParam(item);
                                            }}
                                        >选择</div>}
                                    </div>
                                    <div className="body-cell flex-1">{item?.sensorAddressCode || ''}</div>
                                    <div className="body-cell flex-1">{item?.sensorChannel || ''}</div>
                                    <div className="body-cell flex-2">
                                        {item?.dataBoxCode && <div className='have-border' onClick={() => {
                                            commonTabbarContext.navigate(`${TAB_TYPE.DEVICE}/${item?.dataBoxId}/${DEVICE_TYPE.DATA_BOX}`)
                                        }}>{item?.dataBoxCode || ''}</div>}
                                    </div>
                                    <div className="body-cell flex-2">{item?.dataBoxImei || ''}</div>
                                    <div className="body-cell flex-1">
                                        {item?.sensorId && <div className='have-border'
                                            style={{ width: 40, cursor: 'pointer' }}
                                            onClick={() => {
                                                commonTabbarContext.navigate(`${TAB_TYPE.DEVICE}/${item?.sensorId}/${DEVICE_TYPE.SENSOR}`)
                                            }}
                                        >测试</div>}
                                    </div>
                                    <div className="body-cell flex-1">
                                        <div className={classNames({
                                            "warning": true,
                                            "warning-t0": item?.warningLevel === WARNING_LEVEL.NONE,
                                            "warning-t1": item?.warningLevel === WARNING_LEVEL.T2,
                                            "warning-t2": item?.warningLevel === WARNING_LEVEL.T3,
                                            "warning-t3": item?.warningLevel === WARNING_LEVEL.T4,
                                        })}>{getWarningLevelName(item?.warningLevel)}</div>
                                    </div>
                                </div >
                            </>
                        )
                    })}
                </div>
            </Skeleton >

            {selectSensorVisiable && <SelectSensorRelationModal
                visible={selectSensorVisiable}
                setVisible={setSelectSensorVisiable}
                onFinish={onSelectSensorFinish}
                selectParam={selectParam}
                loading={modalLoading}
            />
            }
        </div >
    )
}